<div class="user">
  <router-outlet></router-outlet>
</div>
